import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Logs } from '../models/logs.model';
import { ApiKeyGeneratorService } from './api-key-generator.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  private apiUrl: string;

  constructor(
    private api: ApiService,
    private http: HttpClient,
    private _apiKeyService: ApiKeyGeneratorService
  ) {
    this.apiUrl = `${this.api.getRootApiUrl()}/shared/logs`;
  }

  insert(logs: Logs) {
    return this.http.post(`${this.apiUrl}`, logs, {
      headers: this._apiKeyService.getApiKeyHeaders()
    });
  }
}
